<template>
    <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 19.65 14.05"
    >
        <path
            id="Icon_metro-youtube-play-2"
            data-name="Icon metro-youtube-play-2"
            class="cls-1"
            d="M14,7a.62.62,0,0,0-.33-.59L8.09,2.92a.67.67,0,0,0-.71,0A.64.64,0,0,0,7,3.51v7a.64.64,0,0,0,.36.61.67.67,0,0,0,.34.09.7.7,0,0,0,.37-.11l5.62-3.51A.63.63,0,0,0,14,7Zm5.61,0c0,.7,0,1.25,0,1.65s0,.89-.09,1.5a11,11,0,0,1-.25,1.61,2.53,2.53,0,0,1-.75,1.35,2.34,2.34,0,0,1-1.36.64A72.31,72.31,0,0,1,9.82,14a72.12,72.12,0,0,1-7.35-.27,2.34,2.34,0,0,1-1.37-.64,2.54,2.54,0,0,1-.76-1.35A14.53,14.53,0,0,1,.1,10.17Q0,9.27,0,8.67c0-.4,0-1,0-1.65S0,5.77,0,5.38s0-.9.09-1.5A12.68,12.68,0,0,1,.35,2.26,2.55,2.55,0,0,1,1.11.92,2.34,2.34,0,0,1,2.47.28,69.35,69.35,0,0,1,9.82,0a69.44,69.44,0,0,1,7.36.27,2.39,2.39,0,0,1,1.37.64,2.61,2.61,0,0,1,.76,1.35,12.48,12.48,0,0,1,.23,1.61c.06.6.09,1.1.1,1.5s0,1,0,1.64Z"
        />
    </svg>
</template>

<script>
export default {
    name: 'VideoIcon'
}
</script>

<style lang="scss" scoped>
svg {
    width: 19.65px;
    height: 14.05px;
    margin: auto;
    path {
        fill: $white;
    }
}
svg:hover {
    path {
        fill:$blue;
    }
}
</style>